import React from 'react';
import { Link } from 'react-router-dom';
import { Price } from '../../../../../UI/Price/Price';

export class ChanelProductDetailSwatches extends React.Component {
  render() {
    var swatchGroups = JSON.parse(JSON.stringify(this.props.swatchGroups));
    var settings = {
      dots: false,
      infinite: false,
      vertical: false,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 1,
      swipe: true,
      lazyLoad: true,
      variableWidth: true,
    };
    return (
      <div className='swatch-groups'>
        {swatchGroups && swatchGroups.length > 0
          ? swatchGroups.map((swatchGroup, index) => (
              <div key={index} className='productDisplay__div--swatch-group'>
                {swatchGroups.length > 1 || this.props.contentData.onSpecial ? (
                  <Price pricing={swatchGroup.pricing} />
                ) : (
                  ''
                )}
                <ul className='swatches'>
                  {swatchGroup.swatches.map((swatch) => (
                    <li key={swatch.swatchImg} className='swatches__item'>
                      <img
                        className={`${'swatches__img'} ${this.props.isAttrAvailable(swatch.colorForSwatch) ? 'swatches__img--available' : 'swatches__img--notAvailable'}${this.props.selectedAttributeValue == swatch.colorForSwatch ? ' swatches__img--selected' : ''}`}
                        key={swatch.swatchImg}
                        src={`//dimg.dillards.com/is/image/DillardsZoom/${swatch.swatchImg}`}
                        alt={`Color Swatch - ${swatch.colorForSwatch}`}
                        onClick={this.props.passedFunctions.updateAttribute}
                        data-attrval={swatch.colorForSwatch}
                        data-attrid='Swatch'
                      />
                    </li>
                  ))}
                </ul>
              </div>
            ))
          : ''}
      </div>
    );
  }
}

export default ChanelProductDetailSwatches;
